/* Size Guide right drawer — DEV prototype. Independent of the existing modal. */
(function () {
  'use strict';

  var DRAWER_ID = 'size-guide-drawer';
  /* Unique open class — theme custom.js closes every `.is-open` on
     outside click, and garment table re-renders detach the click target
     so closest('.is-open') fails and the drawer was getting nuked. */
  var OPEN_ATTR = 'SizeGuideDrawer--open';
  var lastFocus = null;

  function drawer() {
    return document.getElementById(DRAWER_ID);
  }

  function panel(root) {
    return root && root.querySelector('[data-size-guide-drawer-panel]');
  }

  function openDrawer() {
    var root = drawer();
    if (!root) return;

    lastFocus = document.activeElement;
    root.classList.add(OPEN_ATTR);
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('SizeGuideDrawer--locked');
    document.body.classList.add('SizeGuideDrawer--locked');

    // Garment Measurements when that tab exists, otherwise Body Measurements.
    var $container = window.jQuery
      ? window.jQuery(root).find('.custom----size-chart-variant').first()
      : null;
    if ($container && $container.length && typeof window.resetSizeGuideDefaultTab === 'function') {
      window.resetSizeGuideDefaultTab($container);
    } else if ($container && $container.length) {
      var btn = root.querySelector('.sizechart-tab[aria-controls^="tab-measurements"]')
        || root.querySelector('.sizechart-tab[aria-controls^="tab-body-measurements"]');
      if (btn) btn.click();
    }

    // Re-init garment mockup if that tab was already visited.
    if (window.StAgniGarmentMeasurementD20 && typeof window.StAgniGarmentMeasurementD20.initAll === 'function') {
      setTimeout(function () {
        window.StAgniGarmentMeasurementD20.initAll();
      }, 60);
    }

    var closeBtn = root.querySelector('.SizeGuideDrawer__Close');
    if (closeBtn) {
      setTimeout(function () { closeBtn.focus(); }, 50);
    }
  }

  function closeDrawer() {
    var root = drawer();
    if (!root || !root.classList.contains(OPEN_ATTR)) return;

    root.classList.remove(OPEN_ATTR);
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('SizeGuideDrawer--locked');
    document.body.classList.remove('SizeGuideDrawer--locked');

    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus(); } catch (e) {}
    }
    lastFocus = null;
  }

  function isOpen() {
    var root = drawer();
    return !!(root && root.classList.contains(OPEN_ATTR));
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest && e.target.closest('[data-action="open-size-guide-drawer"]');
    if (openTrigger) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
      return;
    }

    var closeTrigger = e.target.closest && e.target.closest('[data-action="close-size-guide-drawer"]');
    if (closeTrigger) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) {
      e.preventDefault();
      closeDrawer();
    }
  });

  // Expose for debugging / other scripts.
  window.StAgniSizeGuideDrawer = {
    open: openDrawer,
    close: closeDrawer,
    isOpen: isOpen
  };
})();

/* Prevent background scroll while the drawer is open. */
(function () {
  var style = document.createElement('style');
  style.textContent =
    'html.SizeGuideDrawer--locked, body.SizeGuideDrawer--locked { overflow: hidden !important; }';
  document.head.appendChild(style);
})();
